module.exports = __webpack_public_path__ + "static/ac-362585808f59a0f6978de6da5e1b067d.jpg";